import { useRef } from 'react';

export const useKeyboardNavigation = () => {
  const phoneNumberRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const streetRef = useRef<HTMLInputElement>(null);
  const stateRef = useRef<HTMLInputElement>(null);
  const pincodeRef = useRef<HTMLInputElement>(null);

  return {
    inputRefs: {
      phoneNumberRef,
      emailRef,
      streetRef,
      stateRef,
      pincodeRef
    }
  };
};